import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React, { useContext } from 'react';
import { useParams } from 'react-router';

import type { GoogleAdsSmartCampaign } from '@feathr/blackbox';
import Page from '@feathr/extender/App/Page';
import { StoresContext } from '@feathr/extender/state';

import GoogleAdsCampaignEdit from './GoogleAdsCampaignEdit';

import campaignsJSON from '@feathr/blackbox/fixtures/campaigns.json';

function GoogleAdsCampaignPage(): JSX.Element {
  const { Campaigns } = useContext(StoresContext);
  const { campaignId } = useParams<{ eventId: string; campaignId: string }>();

  const campaign = Campaigns.create(
    campaignsJSON?.data.find((o) => o.id === campaignId),
  ) as GoogleAdsSmartCampaign;

  return (
    <Page title={campaign.get('name')}>
      <GoogleAdsCampaignEdit campaign={campaign} />
    </Page>
  );
}

export default observer(GoogleAdsCampaignPage);
